import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { marker } from '@eventlyte/common';
import { AnalyticsCode, LanguageSelector } from '@eventlyte/registration';
import { TranslocoDirective } from '@jsverse/transloco';
import { AppRoutePaths } from './app.routes';

@Component({
	selector: 'app-root',
	imports: [RouterOutlet, LanguageSelector, TranslocoDirective, AnalyticsCode],
	templateUrl: './app.html',
	styleUrls: ['./app.scss']
})
export class App {
	markers = [
		marker('content.validation.duplicateEmailInBatch'),
		marker('content.validation.duplicateMobileInBatch'),
		marker('content.validation.duplicateEmailExistingRecord'),
		marker('content.validation.duplicateMobileExistingRecord')
	];

	protected readonly title = signal('Events.Customers.BaobabTree.BGOV.Angular');
	private router = inject(Router);
	private activatedRoute = inject(ActivatedRoute);

	public ngOnInit(): void {
		this.router.events.subscribe(() => {
			let route = this.activatedRoute;

			while (route.firstChild) {
				route = route.firstChild;
			}

			route.queryParamMap.subscribe((params) => {
				if (params.get('origin')) {
					sessionStorage.setItem('origin', params.get('origin')!);
				}
			});
		});
	}

	protected isLandingPage(): boolean {
		const pathOnly = (this.router.url.split(/[?#]/)[0] || '/').trim();
		const withoutIndex = pathOnly.replace(/\/index\.html$/i, '/');
		const normalized = withoutIndex !== '/' ? withoutIndex.replace(/\/+$/, '') : '/';

		return normalized === AppRoutePaths.LandingPage;
	}
}
